export class AuthenticationData {
  constructor(
    protected _username: string,
    protected _uid: string,
    protected _token: string,
    protected _csrf: string,
    protected _logout: string,
    protected _exp: Date
  ) { }

  get token(): string {
    return this._token;
  }

  get username(): string {
    return this._username;
  }

  get uid(): string {
    return this._uid
  }

  get csrf(): string {
    return this._csrf;
  }

  get logout(): string {
    return this._logout;
  }

  get exp(): Date {
    return this._exp;
  }

  public serialize(): string {
    return JSON.stringify(this);
  }

  public static unserialize(serializedUser: string): AuthenticationData {
    const unserliazedRawUser = JSON.parse(serializedUser);
    return new AuthenticationData(
      unserliazedRawUser._username,
      unserliazedRawUser._uid,
      unserliazedRawUser._token,
      unserliazedRawUser._csrf,
      unserliazedRawUser._logout,
      new Date(unserliazedRawUser._exp)
    );
  }
}
